module.exports = new __parcel__URL__("space_cactus_level_1.764af65f.png").toString();